import { IDateRangeQuery } from '../interfaces/date-range-query.interface';

// @dynamic
export class DateRange {
    startDate: Date;
    endDate: Date;

    constructor(query: IDateRangeQuery) {
        if (query) {
            this.startDate = query.start_date;
            this.endDate = query.end_date;
        } else {
            this.startDate = null;
            this.endDate = null;
        }
    }
}
